module.exports = {
	"signin": "Sign In",
	"signup": "Sign Up",
	"login": "Login",
	"password": "Password",
	"confirmPassword": "Confirm password",
	"validate": "Validate",
	"firstname": "Firstname",
	"lastname": "Lastname",
	"mobile": "Mobile",
	"phone": "Phone",
	"address": "Address",
	"zip": "zip code",
	"city": "City",
	"home": "Home",
	"administration": "Administration",
	"administrativeLimits": "Administrative Limits",
	"administrativeLimit": "Administrative Limit",
	"tutorial": "Tutorial",
	"signOut": "SignOut",
	"connection": "Connection",
	"legalNotice": "Legal Notice",
	"news": "News",
	"forgotPassword": "Forgot Password?",
	"needHelp": "Need help ?",
	"error": {
		"login": "Login",
		"mandatoryTheme": "You can't unselect this theme for the moment",
		"password": "Password",
		"mail": "Mail",
		"captcha": "Captcha",
		"incorrectEmail": "Incorrect Email",
		"notFound": "Page Not Found",
		"nonexistent": "None Existent Station",
		"errorDuringExport": "Error During Export",
		"errorLoadingData": "Error While Loadin Data",
		"noWatershedSelection": "No Watershed Found In Your Selection",
		"pleasePhoneInform": "Please Indicate Your Phone Number",
		"pleaseNameInform": "Please Indicate Your Name",
		"criteriaLimited10": "Number of Criterias Limited to 10",
		"radiusLimited20km": "Possible Radius Limited To 20km (12,42 Miles)",
		"cannotDeleteSite": "Impossible To Delete Your Sites",
		"cannotGetSelection": "Cannot Get Selections",
		"cannotSaveInformation": "Cannot Save Your Information",
		"errorOccurredExportingSelection": "Error Occurred During The Export Of Your Selection",
		"errorRequestingCredits": "Error During Your Credit Request",
		"pleaseFillLeastTheme": "Please Fill At Least One Theme",
		"samePassword": "Password are not the same",
		"thanksContactSupport": "Thank's contact support for more informations.",
		"notAllowToConnect": "You're not allow to connect.",
		"notRegister": "You're not register in own database. Please subscribe.",
		"loginError": "Unauthorized login"
	},
	"mail": "Mail Address",
	"page": "Page",
	"signupSuccess": "Welcome to AquaDB. We have sent you an e-mail so you can finish your registration",
	"findEmailSuccess": "We have sent you an e-mail so you can change your password",
	"name": "Name",
	"save": "Save",
	"success": "Successful",
	"piezometer": "Piezometer",
	"code": "Code",
	"cityid": "City ID Number",
	"nafCode": "NAF Code",
	"icpeScheme": "ICPE Scheme",
	"family": "Family",
	"longitude": "Longitude",
	"longi": "Longi",
	"zoom": "Zoom",
	"fullScreen": "Full Screen",
	"customZoom": "Customized Zoom",
	"latitude": "Latitude",
	"lati": "Lati",
	"numberOfMeasure": "Measure Number",
	"firstDate": "Start Date",
	"openingDate": "Opening Date",
	"closingDate": "Closing Date",
	"lastDate": "Ending Date",
	"lastMeasure": "Last Measure",
	"qualitometer": "Qualitometer",
	"nbOperation": "Operation Number",
	"nbAnalysis": "Analysis Number",
	"numberAnalysis": "Number of Analyses",
	"nbMeasure": "nbMeasure",
	"numberMeasure": "numberMeasure",
	"surfaceQualitometer": "Surface Qualitometer",
	"mostDetectedMolecules": "Most Detected Molecules",
	"pollutedSoil": "Polluted Soil",
	"industrialSite": "Industrial Sites",
	"siteReseach": "Site Search",
	"stationResearch": "Point Search",
	"stationForm": "Station Details",
	"searchLaunch": "Search Launch",
	"advancedSearch": "Advanced Search",
	"element": "Item",
	"elements": "Items",
	"lowerOperation": "Lower Operation",
	"lowerOperations": "Lower Operations",
	"parameters": "Parameters",
	"lowerParameter": "Lower Parameter",
	"lowerParameters": "Lower Parameters",
	"quantity": "Quantity",
	"min": "Min",
	"max": "Max",
	"creation": "Creation",
	"update": "Update",
	"restore": "Restore",
	"lastExecution": "Last Execution",
	"nbSites": "Number Of Sites",
	"nbFilters": "Number Of Filters",
	"nbThemes": "Number of Themes",
	"selectYourTheme": "Select Your Themes",
	"town": "City",
	"towns": "Citys",
	"watershed": "Watershed",
	"research": "Search",
	"researchs": "Search",
	"perimeterSearch": "Search By Perimeter ",
	"namePostcodeInsee": "Search Using Name, ZIP or  INSEE code",
	"clickMapDrawCircle": "Click On Map And Draw A Circle From There",
	"drawShapeAndDoneArea": "Draw A Shape, Search Will Be Performed Within Chosen Area",
	"uploadKmlAndSearch": "Upload KML, Search Will Be Performed On KML",
	"kmlSearch": "Search By KML",
	"citySearch": "Search By City",
	"title": "Title",
	"filters": "Filters",
	"selection": "Selection",
	"selections": "Selections",
	"site": "Site",
	"filter": "Filter",
	"station": "Station",
	"stations": "Stations",
	"nbStation": "Station Number",
	"themes": "Themes",
	"theme": "Theme",
	"map": "Map",
	"informations": "Information",
	"myResearch": "My research",
	"myInformations": "My Information",
	"myCredits": "My Credits",
	"credits": "Credits",
	"credit": "Credit",
	"simpleCredit": "credit",
	"simplePlurialCredit": "credits",
	"saveSelectionPlaceholder": "Put selection title",
	"radius": "Radius",
	"drawing": "Drawing",
	"nbFilter": "Number of Filters",
	"nbTheme": "Number of Themes",
	"creationDate": "Creation Date",
	"updateDate": "Last Update",
	"lastExecutionDate": "Last Date Of Execution",
	"executionFunction": "Process",
	"deleteFunction": "Delete",
	"deleteSelection": "Delete Selection",
	"informationFunction": "Informations",
	"exportFunction": "Export",
	"noData": "No Data",
	"noSites": "No sites",
	"noNameSelection": "No Name For This Selection",
	"analysis": "Analysis",
	"analyses": "Analyses",
	"lowerAnalysis": "Lower Analysis",
	"lowerAnalyses": "Lower Analyses",
	"measure": "Measure",
	"measures": "Measures",
	"measureMin": "measure",
	"measuresMin": "measures",
	"sources": "Sources",
	"source": "Source",
	"nbExport": "Numer Of Exports",
	"numberExport": "Number Of Exports",
	"lastExport": "Last Export",
	"dataAvailable": "Available Data",
	"sitesAvailable": "Sites available",
	"noDataAvailableQuality": "Quality - No Data Available",
	"isUpdateData": "Updated Data",
	"export": "Export",
	"exports": "Exports",
	"minute": "Minute",
	"seconde": "seconde",
	"secondes": "secondes",
	"selectionCost": "Selection cost",
	"saveSelection": "Save the selection",
	"saveTheSelection": "Saved selection",
	"expiredDownload": "Download Expired",
	"insufficientCreditExport": "Insufficient Credit To Allow Export",
	"executionTime": "Execution Time",
	"cancel": "Cancel",
	"executeResearch": "Start Searching",
	"exportSelection": "Export the selection",
	"graphicView": "Graphical View",
	"cartographicView": "Map View",
	"nbWatershed": "Watershed Areas",
	"watersheds": "Watershed Areas",
	"lowerWatersheds": "Lower Watershed Areas",
	"hydrographicEntity": "Watershed Entity",
	"annualChart": "Annual Chart",
	"historicalChart": "Historical Chart",
	"annualAverageLevels": "Mean Annual Levels",
	"recharge": "Reload",
	"indicator": "Indicator",
	"indicatorMin": "indicator",
	"indicatorsMin": "indicators",
	"population": "Population",
	"selectionLoading": "Loading Of Your Selection",
	"uploadingRepositories": "Uploading Of Repositories",
	"loadingKeyFigures": "Loading Key Figures",
	"loadingSelectedStations": "Loading Of Selected Stations",
	"loadingWatershed": "Loading watershed",
	"loadingCities": "Loading cities",
	"loadingStations": "Loading stations",
	"loadingYourFilters": "Loading Of Your Filters",
	"status": "Status",
	"state": "State",
	"annualChronicle": "Annual Chronicle",
	"middleChronicle": "Mean Chronicle",
	"envelope": "Envelope",
	"fromNetwork": "Network Based",
	"type": "Type",
	"quality": "Quality",
	"support": "Support",
	"watershedArea": "Watershed Area",
	"lowerWatershedArea": "watershed Area",
	"point": {
		"denomination": "Name",
		"code": "Code",
		"localization": "Localization",
		"city": "City",
		"network": "Network",
		"watershed": "Watershed Area",
		"samplingPoint": "Sampling Point",
		"samplingPoints": "Sampling Points",
		"coordinate": "Coordinates",
		"longitude": "Longitude",
		"latitude": "Latitude",
		"altitude": "Altitude",
		"loading": "Loading Of Your Points",
		"sheet": "Data Sheet"
	},
	"question": {
		"executeResearch": "Do You Really Want To Perform This Search ?",
		"exportSelection": "What information do you want to download?",
		"deleteSelection": "Do You Really Want To Delete This Selection ?"
	},
	"information": {
		"updateCredit": "You Need More Credit To Perform This Export",
		"contactAddCredit": "Please Contact AquaDB For More Credit",
		"finalCreditAfterExport": "After The Export, Your Remaining Credit Will Be"
	},
	"warning": {
		"pleaseMailInform": "Please Enter An E-Mail",
		"noSelectionDeletion": "No Selection Available To Deleate",
		"noInformationAvailable": "No Information Available",
		"noCodeNoticed": "No Notice Code",
		"pleaseSiteSelection": "Please Select At Least One Site",
		"pleaseTitleInform": "Please Add A Title",
		"pleaseRecreditAccount": "Please Recredit My Account",
		"pleaseFillLeastFilter": "Please Choose At Least One Filter",
		"noInformationAvailableMunicipalities": "No Information Available For These Towns",
		"noDataAvailableSite": "No Data Available For This Site",
		"selectionLimit": "Slection limited 5 for Beta version"
	},
	"multi": {
		"last": "Last",
		"lastMin": "last",
		"saved": "Saved",
		"your": "Your"
	},
	"layersAvailable": "Available Layers ",
	"layerAvailable": "Available Layer ",
	"noLayerAvailable": "No Layer Available For These Themes",
	"cartographicLayers": "Map Layers",
	"layers": "Layers",
	"siteTypesAvailable": "Type Of Points Available",
	"stationTypes": "Station Types",
	"points": "Points",
	"last": "Last",
	"lastMin": "last",
	"lowerSelection": "Lower Selection",
	"lowerSelections": "Lower Selections",
	"saved": "Saved",
	"accountInformations": "Account Informations",
	"mapPreferences": "Map Preferences",
	"description": "Description",
	"reference": "Reference",
	"of": "Of",
	"to": "To",
	"lowerOn": "On",
	"proximityPoints": "Points In The Area",
	"unknown": "Unknown",
	"lastUpdate": "Last Update",
	"managementWater": "Water Management",
	"ask": "Ask",
	"myAccount": "My Account",
	"finish": "Finish",
	"next": "Next",
	"previous": "Previous",
	"deletedSites": "Sites Have Been Deleted",
	"notYetRegistered": "Not Yet Registered ?",
	"aquasysCopyright": "Aquasys Copyright",
	"aquasysContact": "Aquasys Contact",
	"contactUs": "Contact Us",
	"aquasys": "Aquasys",
	"aquaDB": "AquaDB",
	"close": "Close",
	"activityArea": "Activity Area",
	"notSpecified": "Not Specified",
	"geographicalCriteriaResearch": "Enter site name, city or hydrological area code",
	"addNewSelection": "Add A New Selection",
	"addNewSelectionSuccess": "Yor New Selection Has Been Successfully Added, You Will Receive An E-Mail As Soon As Your Selection Has Has Been Downloaded",
	"receiveEmailDownloadLink": "You Will Receive An E-Mail With A link To Download",
	"savedSelection": "Your Selection Has been Saved",
	"deletedSelection": "Your Selection Has been deleted",
	"legend": "Keys",
	"defaultLegend": "Default Keys",
	"availableCaption": "Available Key",
	"availableCaptions": "Available Keys",
	"availablePoint": "Available Point",
	"availablePoints": "Available Points",
	"selectLayerDisplayLegend": "Select A Layer To Display Associated Keys",
	"comment": "Comment",
	"dataHistory": "Data History",
	"historical": "Historical",
	"distance": "Distance",
	"displayMore": "Display more",
	"availableCredit": "Available Credit",
	"availableCredits": "Available Credits",
	"download": "Download",
	"exportInProgress": "Export Process In Progress",
	"inProgress": "In Progress",
	"processDevelopment": "Ongoing Development",
	"accepted": "I Accept",
	"stopDisplaying": "No longer display it",
	"selectData": "Select point",
	"filterDataByTheme": "Filter point by theme",
	"display": "Display",
	"more": "more",
	"displayLayers": "Display map layers",
	"noNewsToDisplay": "No news to display",
	"aquadbTitle": "Download water and environment open data in 1 click!",
	"aquadbDevelopedBy": "A service developed by",
	"cookie": {
		"description": "By Staying On This Web Site You Accept Our Use of Cookies for Measurement And Advertising Purposes",
		"more": "Learn More And Manage Cookies",
		"moreTitle": "How We Use Cookies",
		"communication": "Communication",
		"statistics": "Statistics",
		"communicationComment": "By Continuing On This Site You Accet Our Use Of Information Concerning You for Internal Communication Purposes",
		"statisticsComment": "By Continuing On This Site You Accept Our Use Of Information Concerning You In Order To Generate Statistics "
	},
	"selectByHydrologicArea": "Select by hydrographic area",
	"selectByPointType": "Select by point type",
	"reflate": "Reflate",
	"mySelections": "My selections",
	"advancedResearch": "Advanced research",
	"criteriaLimitBeta": "For more research criteria, please create free account",
	"alreadyRegistered": "Already registered ?",
	"loginInSuccess": "Welcome ",
	"loginOutSuccess": "Logout success",
	"department": "Department",
	"departments": "Departments",
	"dataSource": "Data source",
	"cglu": "CGLU",
	"data": "Data",
	"datas": "Data",
	"favorite": "Favorite",
	"favoriteFunction": "Favorite",
	"favoriteResearch": "Favorite research",
	"favoriteResearchs": "Favorites research",
	"csvExport": "Export research list",
	"addCredit": "Add credit",
	"selectionExportCredit": "Selection export",
	"saveResearch": "Save research",
	"saveResearchs": "Save researchs",
	"mapGenerate": "Map loading",
	"dataRecuperation": "Data recuperation"
};


//////////////////
// WEBPACK FOOTER
// ./public/i18n/properties_en.json
// module id = 2219
// module chunks = 0